import { Col, Row, Text } from 'components';
import { useInfiniteScrollObserver } from 'core';
import { Api } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Header, PricingPanel } from 'screens/Admin/components';
import {
    ConnectOneOnOneList, Filters, ShoutoutFromAthleteList, ShoutoutToAthleteList, ShoutoutToTeamsList, SubscriptionsList, TierAssignments
} from './components';

const Pricing = ({}) => {
  const [dataId, setDataId] = useState(null),
    [filter, setFilter] = useState('shoutout-to-athletes'),
    [paymentType, setPaymentType] = useState('shoutoutToAthlete'),
    [isPameo, setIsPameo] = useState(filter === 'shoutout-from-athletes'),
    [limit, setLimit] = useState(0),
    [loading, setLoading] = useState(true),
    [panelHeader, setPanelHeader] = useState('Shoutout to Athletes'),
    athleteTiers = useSelector((state) => state.admin?.athleteTiers),
    fetching = useRef(false),
    bottom = useRef(false),
    skip = useRef(0),
    dispatch = useDispatch(),
    scrollId = 'admin-pricing-list',
    observerTarget = useRef(null);

  function handleFilterChange(val) {
    setFilter(val === filter ? null : val);
    setIsPameo(val === 'shoutout-from-athletes');

    switch (val) {
      case 'shoutout-to-athletes':
        setPaymentType('shoutoutToAthlete');
        setPanelHeader('Shoutout to Athletes');
        break;
      case 'shoutout-from-athletes':
        setPaymentType('shoutoutFromAthlete');
        setPanelHeader('Shoutout from an Athlete');
        break;
      case 'one-on-one-connect':
        // setPaymentType('f2f')
        break;
      case 'subscriptions':
        // setPaymentType('subscriptions')
        break;
      case 'shoutout-to-teams':
        // setPaymentType('shoutoutToTeam')
        break;
      default:
    }
  }

  useInfiniteScrollObserver(observerTarget, getAthleteTiers, bottomTrigger);

  useEffect(() => {
    getAthleteTiers(true).then();
  }, []);

  useEffect(() => {
    if (fetching.current || loading) {
      return;
    }

    getAthleteTiers(true).then();
  }, [filter]);

  useEffect(() => {
    let index = athleteTiers?.length || 0;

    if (!index || loading) {
      return;
    }

    if (index !== limit) {
      skip.current = index;
    } else {
      bottomTrigger(true);
    }
  }, [athleteTiers]);

  function handleSelect(tierId) {
    setDataId(tierId);
  }

  function bottomTrigger(value) {
    bottom.current = value;
  }

  async function getAthleteTiers(isFilterChange) {
    // allow shoutoutFromAthletes only for now
    if (filter !== 'shoutout-from-athletes' && filter !== 'shoutout-to-athletes') {
      return;
    }

    if (isFilterChange) {
      dispatch({
        type: 'ADMIN_SET_ATHLETE_TIERS',
        payload: []
      });
      setLoading(true);
      skip.current = 0;
      bottomTrigger(false);
    }

    if (fetching.current || bottom.current) {
      return;
    }

    fetching.current = true;

    /**
     * @property {number} length
     */
    const res = await Api.get(
      `/admin/athleteTiers?paymentType=${paymentType}&skip=${skip.current}`
    );

    fetching.current = false;
    setLoading(false);

    if (!res || res.length === 0) {
      bottomTrigger(true);
      return;
    }

    bottomTrigger(false);

    dispatch({
      type: 'ADMIN_ADD_ATHLETE_TIERS',
      payload: res
    });
  }

  return (
    <Col wid="100%" ht="100vh" flexStart>
      <Header>
        <Row center>
          <Text h3>Pricing</Text>
        </Row>
      </Header>

      <Col
        flexStart
        noFlex
        marg="54px 0 0"
        wid="100%"
        ht={isPameo ? 'calc(100vh - 55px)' : '100vh'}
        id={scrollId}
        scrollY
        style={isPameo ? { minHeight: '700px' } : {}}
      >
        <Filters filter={filter} handleFilterChange={handleFilterChange} />
        {filter === 'shoutout-to-athletes' && (
          <>
            <ShoutoutToAthleteList
              // data={athleteTiers}
              // dataId={dataId}
              // onClick={handleSelect}
              filter={filter}
              loading={loading}
            />
            <div ref={observerTarget}></div>
          </>
        )}
        {filter === 'shoutout-from-athletes' && (
          <>
            <ShoutoutFromAthleteList
              data={athleteTiers}
              dataId={dataId}
              onClick={handleSelect}
              loading={loading}
            />
            <div ref={observerTarget}></div>
            <TierAssignments
              loading={loading}
              athleteTiers={athleteTiers && athleteTiers.filter((tier) => !tier.default)}
            />
          </>
        )}
        {filter === 'one-on-one-connect' && (
          <ConnectOneOnOneList filter={filter} loading={loading} />
        )}
        {filter === 'subscriptions' && <SubscriptionsList filter={filter} loading={loading} />}
        {filter === 'shoutout-to-teams' && (
          <ShoutoutToTeamsList loading={loading} dataId={dataId} />
        )}
        <PricingPanel
          dataId={dataId}
          setDataId={handleSelect}
          closeModal={() => setDataId(null)}
          panelHeader={panelHeader}
        />
      </Col>
    </Col>
  );
};

export default Pricing;
